// material components
import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ampli } from "../../../ampli";
import { ALERTMESSAGE } from "../../../enums";
// api
import { updateProfileInfo } from "../../../setup/api/services/profile";
import { IMyInfoData } from "../../../setup/api/services/profile/models";
// types
import { IUserInfoResponseData } from "../../../setup/api/services/user/models";
import { fetchAndSetMyInfo } from "../../../setup/context/api";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import Alert, { AlertType } from "../../common/WaffyAlert";
// components
import TextInput from "../../forms/textInput";
import Address from "../address";
// styles
import styles from "./styles.module.scss";
interface Props {
  profileFirstName?: string;
  profileLastName?: string;
  photoUrl?: IUserInfoResponseData["profile"]["photoUrl"];
  updateData: () => void;
}

export enum ALERT {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  NONE = "NONE",
}

const PersonalData = ({
  profileFirstName,
  profileLastName,
  photoUrl,
}: Props): JSX.Element => {
  const userId = AuthConfig.getUserInfo().id;
  const [loading, setLoading] = useState<boolean>(false);
  const [alert, setAlert] = useState<ALERT>(ALERT.NONE);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setlastName] = useState<string>("");
  const { t } = useTranslation();
  useEffect(() => {
    profileFirstName && setFirstName(profileFirstName);
    profileLastName && setlastName(profileLastName);
  }, [profileFirstName, profileLastName, photoUrl]);

  useEffect(() => {
    if (alert !== ALERT.NONE) {
      setTimeout(() => {
        setAlert(ALERT.NONE);
      }, 2000);
    }
  }, [alert]);

  const sendAmpliUserProperties = (data: IMyInfoData) => {
    if (data.id) {
      ampli.client.setUserId(data.id.toString());
      ampli.client.setUserProperties({
        userId: data.id,
        userName: data.profile.fullName || "",
      });
    }
  };
  const setProfileData = async () => {
    setLoading(true);
    const data = {
      firstName: firstName?.trim(),
      lastName: lastName?.trim(),
      photoUrl: photoUrl,
    };
    try {
      if (userId) {
        const res = await updateProfileInfo(userId, data);
        sendAmpliUserProperties(res.data);
        await fetchAndSetMyInfo();
        setAlert(ALERT.SUCCESS);
      }
      setLoading(false);
    } catch (error) {
      Sentry.captureException(error);
      setAlert(ALERT.ERROR);
      setLoading(false);
    }
  };

  return (
    <div className={styles["container"]}>
      <div>
        <h3>{t("lbl_edit_profile_title")}</h3>
        <div className={styles.row}>
          <div className={styles.flex5}>
            <TextInput
              placeholder={t("lbl_form_first_name")}
              required={true}
              label={t("lbl_form_first_name")}
              defaultValue={firstName}
              handleChange={(e) => setFirstName(e?.target?.value)}
            />
          </div>
          <div className={styles.flexDivider} />
          <div className={styles.flex5}>
            <TextInput
              placeholder={t("lbl_form_last_name")}
              required={true}
              label={t("lbl_form_last_name")}
              defaultValue={lastName}
              handleChange={(e) => setlastName(e?.target?.value)}
            />
          </div>
        </div>
      </div>
      {alert !== ALERT.NONE && (
        <Alert
          showIcon
          type={alert === ALERT.SUCCESS ? AlertType.SUCCESS : AlertType.ERROR}>
          {alert === ALERT.SUCCESS
            ? t(ALERTMESSAGE.SUCCESS)
            : t(ALERTMESSAGE.ERROR)}
        </Alert>
      )}
      <Address setProfileData={setProfileData} />
    </div>
  );
};

export default PersonalData;
